import { FC } from 'react'

import {
  Flex,
  GreyGrey60,
  IconClock,
  Primary13Regular,
  Spinner,
  Text
} from '@sequencehq/core-components'

import { NodeTimeline } from '../NodeTimeline'

export const WaitingForNextStepItem: FC<{ 'data-testid': string }> = ({
  'data-testid': dataTestId
}) => (
  <NodeTimeline.Item icon={<IconClock />} showStem={false}>
    <NodeTimeline.Title>
      <Flex data-testid={dataTestId} alignItems="center" gap="6px">
        <Text {...Primary13Regular} color={GreyGrey60}>
          Waiting for next step
        </Text>
        <Spinner size="xs" color={GreyGrey60} />
      </Flex>
    </NodeTimeline.Title>
  </NodeTimeline.Item>
)
